import React from 'react';

import type { BlemishUploadTask } from '../../api/useBlemishImageUpload';

import { UploadStatusItem } from './UploadStatusItem';

import './UploadStatusList.scss';

/** Props for the upload status list */
export interface UploadStatusListProps {
	/** All upload tasks to display (uploading, success, and error) */
	tasks: BlemishUploadTask[];
}

/** Renders a vertical list of upload status items for all active/completed upload tasks */
export const UploadStatusList = ({
	tasks,
}: UploadStatusListProps): React.JSX.Element | null => {
	if (tasks.length === 0) {
		return null;
	}

	return (
		<div className='upload-status-list'>
			{tasks.map((task) => (
				<UploadStatusItem
					key={task.id}
					task={task}
				/>
			))}
		</div>
	);
};
